import { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
import AutoRecommend from "../../components/AutoSuggest";

import {
  fetchVehicleMaintenance,
  resetCreateMaintenanceNote,
  createMaintenanceNote,
} from "../../store/actions/vehicle";
import { showAlertDialog } from "../../store/actions/dialog";
import {
  inputErrorHandler,
  signalTransitionSuccess,
  signalTransitionError,
  removeEmptyValues,
  getFileContent,
  checkFileType,
  getMaxBase64StringSize,
  FILE_TOO_LARGE_MESSAGE,
  FILE_NAME_SEPARATOR,
  FILE_TYPE_MESSAGE,
  CORE_MODULE,
  VEHICLE_MAINTENANCE_NOTE_ENTITY,
} from "../../utils";
import bsCustomFileInput from "bs-custom-file-input";
import ColumnText from "../../components/Column";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "font-awesome/css/font-awesome.css";
import "tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.css";

class MaintenanceNoteAddScreen extends Component {
  maintenanceId = null;
  vehicleId = null;
  vehicleName = null;

  constructor(props) {
    super(props);
    this.maintenanceId = props.match.params.mid;
    this.state = {
      fields: {
        maintenance_id: "",
        maintenance_name: "",
        note: "",
        files: null,
      },

      errors: {
        maintenance_id: "",
        note: "",
        files: null,
      },
      reset: {
        fields: {
          maintenance_id: "",
          maintenance_name: "",
          note: "",
          files: null,
        },
        errors: {
          maintenance_id: "",
          note: "",
          files: "",
        },
      },
      fileName: "No File Choosen",
      defaultName: "No File Choosen",
      value: "",
      suggestions: [],
    };
    this.datePickerHandler = this.datePickerHandler.bind(this);
    this.changeFileHandler = this.changeFileHandler.bind(this);
  }

  componentDidMount() {
    bsCustomFileInput.init();
    let vdata = {};
    vdata.attrs = {};
    vdata.attrs["prefetch"] = ["owning_customer", "vehicle"];
    vdata.conds = {};
    if (this.maintenanceId) {
      vdata.conds = { "me.id": this.maintenanceId };
    }
    this.props.dispatch(fetchVehicleMaintenance(vdata));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.maintenanceData) !==
      JSON.stringify(this.props.maintenanceData)
    ) {
      let maintenances =
        typeof this.props.maintenanceData !== "undefined" &&
        typeof this.props.maintenanceData.rows !== "undefined" &&
        typeof this.props.maintenanceData.rows.data !== "undefined"
          ? this.props.maintenanceData.rows.data
          : [];
      let data = [];
      let suggestions = this.state.suggestions;
      for (let i = 0; i < suggestions.length; i++) {
        let obj = {};
        obj.id = suggestions.id;
        obj.name = suggestions.name;
        data.push(obj);
      }
      for (let i = 0; i < maintenances.length; i++) {
        let obj = {};
        obj.id = maintenances[i].id;
        obj.name = maintenances[i].vehicle.vin;
        data.push(obj);
        data.push(obj);
        if (
          this.maintenanceId &&
          parseInt(this.maintenanceId) === maintenances[i].id
        ) {
          this.vehicleName = maintenances[i].vehicle.vin;
        }
      }
      if (this.maintenanceId) {
        let fields = this.state.fields;
        fields.maintenance_id = this.maintenanceId;
        fields.maintenance_name = this.vehicleName;
        this.setState({ fields: fields });
        if (this.vehicleName) {
          this.setState({ value: this.vehicleName });
        }
      }
      this.setState({ suggestions: data });
    }

    if (this.props.createData.success) {
      this.props.dispatch(resetCreateMaintenanceNote());
      signalTransitionSuccess("Erfolgreich hinzugefügt");
      let url = "/admin/maintenance/" + this.props.match.params.mid + "/notes";
      this.props.history.push(url);
    } else if (this.props.createData.error) {
      this.props.dispatch(resetCreateMaintenanceNote());
      signalTransitionError("Hinzufügen fehlgeschlagen");
    }
  }

  resetHandler(evt) {
    this.setState({ fields: this.state.reset.fields });
    this.setState({ errors: this.state.reset.errors });
  }

  submitHandler(evt) {
    evt.preventDefault();
    // get our new errors

    let fields = this.state.fields;
    //console.log(fields);
    let newErrors = {};
    newErrors["maintenance_id"] = inputErrorHandler(
      "",
      fields.maintenance_id,
      true
    );
    newErrors["note"] = inputErrorHandler("", fields.note, true);
    newErrors["files"] = inputErrorHandler("", fields.files, false);
    if (fields.maintenance_id === "" || fields.maintenance_name === "") {
      newErrors["maintenance_id"] = "Required Parameter";
    } else if (fields.maintenance_name !== this.state.value) {
      newErrors["maintenance_id"] = "Please select valid Maintenance ID";
    }
    let errors = removeEmptyValues(newErrors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
    } else {
      let noteData = { note: {} };

      // noteData.note.date = fields.maint_date;
      noteData.note.attachment = fields.files;
      noteData.note.content = fields.note;
      noteData.note.vehicle_maintenance = fields.maintenance_id;
      //console.log(maintenanceData);
      this.props.dispatch(createMaintenanceNote(noteData));
    }
  }

  changeHandler(evt, name) {
    let value = evt.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: null,
      },
    }));
  }

  datePickerHandler(value) {
    let items = this.state.fields;
    items["maint_date"] = value;
    this.setState({ fields: items });

    let errors = this.state.errors;
    errors["maint_date"] = "";
    this.setState({ errors: errors });
  }

  changeFileHandler(evt) {
    let errors = this.state.errors;
    errors["files"] = "";
    this.setState({ errors: errors });
    if (
      typeof evt.target.files[0] !== "undefined" &&
      typeof evt.target.files[0].name !== "undefined"
    ) {
      this.setState({ fileName: evt.target.files[0].name });
      if (checkFileType(evt.target.files)) {
        getFileContent(evt.target.files)
          .then((data) => {
            if (data.length > getMaxBase64StringSize()) {
              this.props.dispatch(showAlertDialog(FILE_TOO_LARGE_MESSAGE));
              this.setState({ fileName: this.state.defaultName });
              let fields = this.state.fields;
              fields["files"] = "";
              this.setState({ fields: fields });
            } else {
              //console.log(`${this.state.fileName}${FILE_NAME_SEPARATOR}${data}`);
              let fields = this.state.fields;
              fields[
                "files"
              ] = `${this.state.fileName}${FILE_NAME_SEPARATOR}${data}`;
              this.setState({ fields: fields });
            }
          })
          .catch((e) => console.log("Error: ", e.message));
      } else {
        this.props.dispatch(showAlertDialog(FILE_TYPE_MESSAGE));
        this.setState({ fileName: this.state.defaultName });
        let fields = this.state.fields;
        fields["files"] = "";
        this.setState({ fields: fields });
      }
    }
  }

  onValueChange = (newValue) => {
    this.setState({
      value: newValue,
    });
    let errors = this.state.errors;
    errors["maintenance_id"] = "";
    this.setState({ errors: errors });
  };

  onSuggestionsFetchRequested = (value) => {
    this.loadSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  loadSuggestions(value) {
    if (value !== "") {
      let vdata = {};
      vdata.attrs = {};
      vdata.attrs["prefetch"] = ["owning_customer", "vehicle"];
      vdata.conds = { "vehicle.vin": { "-like": "%" + value + "%" } };
      //vdata.conds = { 'me.id':value};
      this.props.dispatch(fetchVehicleMaintenance(vdata));
    }
  }

  loadMoreReferences = () => {
    let meta_data =
      typeof this.props.vehicleData !== "undefined" &&
      typeof this.props.vehicleData.rows !== "undefined" &&
      typeof this.props.vehicleData.rows.meta !== "undefined"
        ? this.props.vehicleData.rows.meta
        : [];

    let vdata = {};
    vdata.attrs = {};
    vdata.conds = meta_data.conds;
    vdata.page = meta_data.page + 1;
    vdata.page_size = meta_data.page_size;
    this.props.dispatch(fetchVehicleMaintenance(vdata));
  };

  onSelect = (suggestionValue) => {
    const reference = this.state.suggestions.find(
      (r) => r["name"] === suggestionValue //.replace('/Maintenance - /i',''),
    );
    let fields = this.state.fields;
    //console.log(reference);
    fields["maintenance_id"] = reference.id;
    fields["maintenance_name"] = reference.name;
    this.setState({ fields: fields });
  };

  render() {
    // let customer_type = 2;

    // let core_module = "core";
    // let vehicle_entity = "vehicle";
    // let maintenance_entity = "vehicle_maintenance";
    // let customer_entity = "customer";
    // let system_module = "system";
    // let client_entity = "client";

    return (
      <div className="wrapper">
        <div className="main d-flex align-items-start flex-column">
          <h4>
            {" "}
            <ColumnText
              Module={CORE_MODULE}
              Entity={VEHICLE_MAINTENANCE_NOTE_ENTITY}
            />{" "}
            hinzufügen
          </h4>
        </div>
        <div className="sub_main">
          <Form>
            <Row>
              <Col lg={6}>
                <Form.Group as={Row} controlId="maintenance_id">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_NOTE_ENTITY}
                      Label={"vehicle_maintenance"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <AutoRecommend
                      value={this.state.value}
                      onValueChange={this.onValueChange}
                      suggestions={this.state.suggestions}
                      onSuggestionsClearRequested={
                        this.onSuggestionsClearRequested
                      }
                      fetchSuggestions={this.onSuggestionsFetchRequested}
                      onSelect={this.onSelect}
                      placeholder="Wählen Sie Wartung"
                      onScrollEnd={this.loadMoreReferences}
                      inputClasses={
                        this.state.errors.maintenance_id !== ""
                          ? "is-invalid form-control"
                          : "form-control"
                      }
                    />
                    {this.state.errors.maintenance_id !== "" ? (
                      <div className="has-error">
                        {this.state.errors.maintenance_id}
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="note">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_NOTE_ENTITY}
                      Label={"content"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Note"
                      name="note"
                      value={this.state.fields.note}
                      onChange={(evt) => this.changeHandler(evt, "note")}
                      onKeyPress={this.onKeyPress}
                      isInvalid={!!this.state.errors.note}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.note}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="mileage">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_NOTE_ENTITY}
                      Label={"attachment"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <Form.File
                      type="file"
                      // className={(this.state.errors.files !== "")?"is-invalid custom-file-label":"form-control custom-file-label"}
                      id="inputGroupFile01"
                      label={this.state.fileName}
                      onChange={(evt) => this.changeFileHandler(evt)}
                      accept="application/pdf, image/*"
                      custom
                      isInvalid={!!this.state.errors.files}
                    />
                    {this.state.errors.files !== "" ? (
                      <div className="has-error">{this.state.errors.files}</div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Form.Group>

                <div className="form-btn">
                  <Button
                    type="Button"
                    className="btn btn-dark Button"
                    onClick={(evt) => this.submitHandler(evt)}
                  >
                    OK
                  </Button>
                  <Button
                    type="Button"
                    className="btn btn-dark"
                    onClick={(evt) => this.resetHandler(evt)}
                  >
                    Abbrechen
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

MaintenanceNoteAddScreen.propTypes = {};
MaintenanceNoteAddScreen.defaultProps = {};

const mapStateToProps = (state) => ({
  customerData: state.Customer.customerData,
  vehicleData: state.Vehicle.vehicleData,
  localeData: state.Locale.localeData,
  createData: state.MNote.createData,
  dialogData: state.Dialog.dialogData,
  maintenanceData: state.Maintenance.maintenanceData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

// We normally do both in one step, like this:
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceNoteAddScreen);
